module.exports = __webpack_public_path__ + "static/media/dental-tech.68971283.jpg";